import { render } from "./NavigationBar.vue?vue&type=template&id=0b5afd8f&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=0b5afd8f&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5afd8f"]])

export default __exports__